import { ContainerModule } from '@evertel/di'
import { RoomMediaSearchController } from './controllers/RoomMediaSearchController'
import { ThreadMediaSearchController } from './controllers/ThreadMediaSearchController'
import { MediaUploadService } from './MediaUploadService'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(RoomMediaSearchController).toSelf()
        m.bind(ThreadMediaSearchController).toSelf()
        m.bind(MediaUploadService).toSelf().inSingletonScope()
    })
]

export { DI_MODULES }
